import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { debounce } from 'throttle-debounce';
import DropDown from 'components/elements/atoms/DropDown/DropDown';
import TextInput from 'components/elements/atoms/FloatingInput/FloatingInput';

export default function DailyCheckInFilters({
  filters,
  setFilters,
  setPage,
  actions,
}) {
  const [schools, setSchools] = useState([]);
  const [courses, setCourses] = useState([]);
  const [searchInput, setSearchInput] = useState(filters.searchQuery || '');

  useEffect(() => {
    async function init() {
      const schoolsRes = await actions.getSchools();
      const coursesRes = await actions.getAdminCourses();

      setSchools(schoolsRes.schools || []);
      setCourses(coursesRes || []);
    }
    init();
  }, []);

  const schoolOptions = useMemo(() => {
    return [
      { label: 'All Schools', value: '' },
      ...schools.map((s) => ({ label: s.name, value: s._id })),
    ];
  }, [schools]);

  const courseOptions = useMemo(() => {
    const sorted = [...courses].sort((a, b) => a.name.localeCompare(b.name));
    return [
      { label: 'All Courses', value: '' },
      ...sorted.map((c) => ({ label: c.name, value: c._id })),
    ];
  }, [courses]);

  const debouncedSearch = useCallback(
    debounce(500, (value) => {
      setPage(1);
      setFilters((prev) => ({ ...prev, searchQuery: value }));
    }),
    [setPage, setFilters]
  );

  return (
    <div className="daily-checkin-filters">
      <div className="daily-checkin-filter-columns">
        <div className="d-flex align-items-center">
          <DropDown
            className="course-dropdown flex-fill"
            labelName="School"
            options={schoolOptions}
            value={filters.schoolId}
            onChange={(schoolId) => {
              setPage(1);
              setFilters({ ...filters, schoolId });
            }}
          />

          <DropDown
            className="course-dropdown flex-fill ml-3"
            labelName="Course"
            options={courseOptions}
            value={filters.courseId}
            onChange={(courseId) => {
              setPage(1);
              setFilters({ ...filters, courseId });
            }}
          />

          <div className="flex-fill ml-3">
            <TextInput
              labelName="Search (username / name / email)"
              name="search"
              className="search-input"
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value);
                debouncedSearch(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
